import type { UploadedImage } from '@prezly/uploadcare';
import { UploadcareImage } from '@prezly/uploadcare';
import type { ImageLoaderProps, ImageProps } from 'next/image';

import type { ImageEffects, ImageSource } from './types';

function getUploadcareImage(src: UploadedImage, effects?: ImageEffects) {
    let image = UploadcareImage.createFromPrezlyStoragePayload(src);
    if (effects?.scaleCrop) {
        image = image.scaleCrop(effects.scaleCrop.width, effects.scaleCrop.height);
    }

    return image;
}

export function getImageDetails(
    src: ImageSource,
    effects?: ImageEffects,
): {
    alt?: string;
    src: ImageProps['src'];
    width?: number;
    height?: number;
} {
    if (UploadcareImage.isPrezlyStoragePayload(src)) {
        const image = getUploadcareImage(src, effects);

        return {
            alt: image.filename,
            src: image.cdnUrl,
            width: image.width,
            height: image.height,
        };
    }

    return { src };
}

// Uploadcare API throws an error if image width exceeds 3000px
const MAX_UPLOADCARE_IMAGE_WIDTH = 3000;

export function createUploadcareImageLoader(src: UploadedImage, effects?: ImageEffects) {
    const image = getUploadcareImage(src, effects);

    // TODO: `@prezly/uploadcare` doesn't support custom effects (needed for quality parameter)
    return function uploadcareLoader({ width }: ImageLoaderProps): string {
        return image.resize(Math.min(width, image.originalWidth, MAX_UPLOADCARE_IMAGE_WIDTH))
            .cdnUrl;
    };
}
